import { OMT_UI_AvatarWithFrame } from '../../OMT_UI/FriendsList/OMT_UI_AvatarWithFrame';
import ShareMsgBase from './A_G.ShareMsgBase';

class MsgEventPostcard extends ShareMsgBase {
  /**
   * The message that is sent when you send through the postcard event
   * @param {number} index
   * @param {string} onAllImagesReadyCallback
   */
  constructor(index, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    // Draw stuff
    const container = new Phaser.Group(game, this);

    // Postcard
    const postcardData = G.OMTsettings.postcardEvent.cardData.postcardData[index];
    const postCard = this._addExtImage(0, 0, postcardData.image, 0, 371, 303, null);
    container.addChild(postCard);

    // Avatar
    const profileContainer = new OMT_UI_AvatarWithFrame(OMT.envData.settings.user.avatar, 90);
    profileContainer.x = postCard.x + postCard.width + profileContainer.width / 2;
    profileContainer.y = postCard.y + postCard.height / 2;

    // Speech bubble and text
    const { slice } = G.OMTsettings.postcardEvent.cardData.speechBubble;
    const speech = G.makeImage(0, 0, 'eventPostcardSpeech', 0, container);
    speech.x = profileContainer.x + (profileContainer.width / 2);
    speech.y = profileContainer.y - speech.height / 2;
    const speechText = new G.Text(0, 0, OMT.language.getText(postcardData.speechText),
      'font-white', [0.5, 0], speech.width - slice.left, speech.height * 0.85, true, 'center');
    speechText.x = 10 + speech.width / 2;
    speechText.y = (speech.height - speechText.height) / 2;
    speech.addChild(speechText);
    container.addChild(profileContainer);

    // Size into message dimensions
    const containerScale = 668 / container.width;
    container.scale.set(containerScale);
    container.x = (668 - container.width) / 2;
    container.y = (354 - container.height) / 2;

    this._objectLoadComplete();
  }
}

G.MsgEventPostcard = MsgEventPostcard;
